<template>
    <div class="form-default" v-if="form != null">
        <form class="form_call" v-if="formVisible && !toManySendingMsg">
            <div class="form-in">
                <div class="form-group form-text">
                    <input type="text" name="name" class="form-control" :placeholder="form.name_mask" v-model="name" v-validate="{ required: true, regex: regexRules.name }"  data-vv-delay="1000">
                    <span class="error-message" v-show="errors.has('name')">{{ errors.first('name') }}</span>
                </div>
                <div class="form-group form-phone">
                    <masked-input v-model="phone" mask="\+\7 (111) 111-11-11" :placeholder="form.phone_mask" class="form-control" name="phone" v-validate="{ required: true, regex: regexRules.phone }" data-vv-delay="1000" v-if="projectHost != 'kohota'"/>
                    <masked-input v-model="phone" mask="\+\998 (11) 111-11-11" placeholder="+998" class="form-control" name="phone" v-validate="{ required: true }" data-vv-delay="1000" v-if="projectHost == 'kohota'"/>
                    <span class="error-message" v-show="errors.has('phone')">{{ errors.first('phone') }}</span>
                </div>
                <VueRecaptcha
                    ref="recaptchaFormFlat"
                    @verify="onCaptchaVerified"
                    :sitekey="salesGcap_siteKey"
                    size="invisible"
                />
                <div class="btn-send">
                    <button class="btn btn-submit btn-success" type="button" @click="sendData" :disabled="errors.any()"><span>{{form.form_sales_promo_btn}}</span></button>
                </div>
            </div>
        </form>
        <div class="successMessage" v-if="!formVisible && !toManySendingMsg">
            <h3>Спасибо! Ваша заявка отправлена.</h3>
        </div>
        <div class="to-many-requests-msg" v-if="toManySendingMsg">
            <span v-if="globalLang == ''">Вы отправили слишком много заявок, попробуйте позднее</span>
            <span v-if="globalLang == 'kz/'">Сіз жіберді тым көп өтінімдерді көріңіз кешіктірмей</span>
            <span v-if="globalLang == 'en/'">You have sent too many requests, please try again later</span>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import MaskedInput from 'vue-masked-input'
    import { VueRecaptcha } from 'vue-recaptcha';
    export default {
        name: 'FormFields',
        data () {
            return {
                globalLang: window.GlobalLang, 
                toManySendingMsg: false,
                phone: '',
                name: '',
                admin_mail: '',
                agree: false,
                formVisible: true,
                projectHost: window.host,
                regexRules: {
                    name: /^([а-яА-ЯёЁa-zA-Z].*[\s\.]*){3,35}$/,
                    phone: /^((8|\+7)[\- ]?)?(\(?\d{3}\)?[\- ]?)?[\d\- ]{10,10}$/,
                    mail: /[a-zA-Z0-9_\.\+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-\.]+/
                }
            }
        },
        components: {
            MaskedInput,
            VueRecaptcha,
        },
        computed: mapGetters({
            form: 'loadForms',
            salesCard: 'loadSalesCardContent',
            saleItem: 'loadSaleCardItem',
            salesGcap_siteKey: 'loadGcap_sitekey',
        }),
        methods: {
            onCaptchaVerified(response) {
                let submissionCounter = localStorage.getItem('shablonformPage_submissionCounter') || 0;
                let lastSubmissionTime = localStorage.getItem('shablonformPage_lastSubmissionTime') || 0;
                var currentMinutes = this.getCurrentMinutes();
                if (currentMinutes - lastSubmissionTime >= 5) {
                    submissionCounter = 0;
                }
                if (submissionCounter >= 5) {
                    this.toManySendingMsg = true;
                    console.log('Превышен лимит отправок формы. Пожалуйста, подождите некоторое время.');
                    return;
                }
                // console.log(response)
                console.log('start sending verify is complete');
                var querystring = require('querystring');
                var data = {
                    'project' : this.saleItem.project_name.slug,
                    'name': this.name,
                    'phone': this.phone,
                    'secret_key' : '0L3QtSDRgdGD0LnRgtC1INGB0LLQvtC5INC90L7RgQ==',
                };
                if (window.host == 'qazyna') {
                    data.project = this.saleItem.project_name.slug.charAt(0).toUpperCase() + this.saleItem.project_name.slug.slice(1);
                }
                this.formVisible = false;
                // console.log(data)
                axios.post('https://admin.sales.bazis.kz/server/form-call.php', querystring.stringify(data))
                .then(() => {
                    submissionCounter++;
                    localStorage.setItem('shablonformPage_submissionCounter', submissionCounter);
                    localStorage.setItem('shablonformPage_lastSubmissionTime', currentMinutes);
                    dataLayer.push({'event' : 'form_sent'})
                })
                .catch(error => {
                    console.error('Form submission error:', error);
                });
            },
            sendData() {
                this.$validator.validate().then(result => {
                    if(result) {
                        console.log('all ok')
                        this.$refs.recaptchaFormFlat.execute();
                        // this.sendInGoogleDoc(data, this.salesCard.city_name_sales.slug);
                    } else {
                        this.errorMsg = true;
                        console.log('Form inputs with errors');
                    }
                });
            },
            getCurrentMinutes() {
                return Math.floor(new Date().getTime() / (1000 * 60));
            },
        },
        created () {
        },
        mounted () {
        }
    }
</script>

<style lang="scss" scoped>
    // @import '@/styles/components/forms/form.scss';
    @import '@/styles/components/forms/form-flat.scss';
    @import '@/styles/components/forms/forms-respond/form-flat-respond.scss';
</style>